// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { listStyles } from "@awc/Overrides/Widgets/ProductList/ProductListCardList";
import { color, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

listStyles.wrapper = {
    css: css`
        margin: 16px 0;
    `,
};

listStyles.cardList = {
    gridContainer: {
        gap: 18,
        css: css`
            &[data-test-selector="productListCards_List"] {
                & > div {
                    margin: 0;
                    justify-content: center;
                    width: 100%;
                    gap: 10px;
                    ${xScreen("lte", "md")} {
                        gap: 16px;
                    }
                }
            }

            &[data-test-selector="productListCards_Table"] {
                & > div {
                    width: 100%;
                    margin: 0;
                }
            }
        `,
    },
};

listStyles.cardContainerStyles = {
    cardDivider: {
        css: css`
            position: relative;
            padding: 0;
            margin: 0;
            width: 100%;
            border: 1px solid ${color("common.border")};
            :before {
                content: "";
                position: absolute;
                left: 0;
                width: 100%;
                height: 6px;
                background-color: ${color("secondary")};
            }
            ${xScreen("lte", "sm")} {
                width: 100%;
                max-width: 342px;
            }
            ${xScreen("lte", "xs")} {
                max-width: 100%;
            }
        `,
    },
    gridItem: {
        width: 12,
        css: css`
            padding: 0;
            ${xScreen("lte", "md")} {
                height: 100%;
            }
        `,
    },
};
listStyles.cardContainerMultiColumnStyles = {
    cardDivider: {
        css: css`
            position: relative;
            padding: 0;
            margin: 0 0 10px 0;
            height: 100%;
            border: 1px solid ${color("common.border")};
            :before {
                content: "";
                position: absolute;
                left: 0;
                width: 100%;
                height: 6px;
                background-color: ${color("secondary")};
            }
        `,
    },
    gridItem: {
        width: [12, 12, 6, 4, 3],
        css: css`
            padding: 9px;
            ${xScreen("lte", "md")} {
                &:nth-child(2n) {
                    justify-content: flex-end;
                }
            }
            ${xScreen("lte", "sm")} {
                &:nth-child(2n) {
                    justify-content: flex-start;
                }
            }
        `,
    },
};
